export function hasRedirectParam(
  searchParams: URLSearchParams,
  expectedValue: string
): boolean {
  return (
    searchParams.get("tgWebAppStartParam") === expectedValue ||
    searchParams.get("startapp") === expectedValue
  );
}
